// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"6":"SknrwContactForm","637":"ApplicationForm","648":"DeStipendiumForm","754":"InfomaterialForm","976":"SknrwApplicationForm","989":"KampagneForm"}[chunkId] || chunkId) + ".css";
};